import { render, staticRenderFns } from "./wordSearchPuzzle.vue?vue&type=template&id=2505775b&scoped=true&"
import script from "./wordSearchPuzzle.vue?vue&type=script&lang=js&"
export * from "./wordSearchPuzzle.vue?vue&type=script&lang=js&"
import style0 from "./wordSearchPuzzle.vue?vue&type=style&index=0&id=2505775b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2505775b",
  null
  
)

export default component.exports